import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-sm text-gray-600 mb-3" }
const _hoisted_2 = { class: "border border-gray-200 rounded-lg divide-y divide-gray-100 max-h-[280px] overflow-y-auto" }
const _hoisted_3 = { class: "min-w-0" }
const _hoisted_4 = { class: "font-semibold text-gray-900 truncate" }
const _hoisted_5 = { class: "text-xs text-gray-500" }
const _hoisted_6 = { class: "font-bold tabular-nums text-gray-900 pl-3" }
const _hoisted_7 = { class: "flex items-center justify-between px-4 py-3 mt-3 bg-gray-50 border border-gray-200 rounded-lg font-bold" }
const _hoisted_8 = { class: "tabular-nums" }

import { ref, computed } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import type { LienData } from '@/models/lienTypes';
import { formatCurrency, pluralizeWithCount } from '@/services/utils';
import QboIcon from '@/components/QboIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LienBulkPushPreviewDialog',
  setup(__props, { expose: __expose }) {

const isVisible = ref(false);
const items = ref<LienData[]>([]);
let resolvePromise: ((value: boolean) => void) | null = null;

const total = computed(() =>
  items.value.reduce((sum, l) => sum + (l.currentAmount ?? 0), 0),
);

/** Open the preview for the given liens; resolves true when confirmed. */
function open(liens: LienData[]): Promise<boolean> {
  items.value = liens;
  isVisible.value = true;
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });
}

function confirm(): void {
  isVisible.value = false;
  resolvePromise?.(true);
  resolvePromise = null;
}

function cancel(): void {
  isVisible.value = false;
  resolvePromise?.(false);
  resolvePromise = null;
}

__expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: isVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isVisible).value = $event)),
    "max-width": "540",
    "data-cy": "bulk-push-preview-dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-lg font-bold" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Submit Liens to QuickBooks", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_1, [
                (items.value.length === 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" A QuickBooks trust check will be created for the following finalized lien. ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" A QuickBooks trust check will be created for each of the following " + _toDisplayString(_unref(pluralizeWithCount)(items.value.length, 'finalized lien')) + ". ", 1)
                    ], 64))
              ]),
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (lien) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: lien.lienId,
                    class: "flex items-center justify-between px-4 py-2.5"
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(lien.vendorDisplayName), 1),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(lien.lienTypeDisplayName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(formatCurrency)(lien.currentAmount)), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[2] || (_cache[2] = _createElementVNode("span", null, "Total", -1)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(formatCurrency)(total.value)), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "pa-6" }, {
            default: _withCtx(() => [
              _createVNode(LlSecondaryButton, {
                "data-cy": "bulk-push-cancel",
                onClick: cancel
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(LlSecondaryButton, {
                variant: "outlined",
                color: "primary",
                "data-cy": "bulk-push-confirm",
                onClick: confirm
              }, {
                default: _withCtx(() => [
                  _createVNode(QboIcon, {
                    size: 16,
                    class: "mr-2"
                  }),
                  _createTextVNode(" Submit " + _toDisplayString(_unref(pluralizeWithCount)(items.value.length, 'lien')) + " to QuickBooks ", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})